// extracted by mini-css-extract-plugin
export default {"tunel":"Humedad_tunel__fepfG","registro":"Humedad_registro__1AM1O"};